module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/DailyPrecipitation100/Nagano_DailyPrecipitation100_MRI_RCP85_End.png";